import React from 'react';
import { connect } from 'react-redux';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import UserCreditsEditView from 'views/Administration/UserCredits/Edit';
import ParticipantService from 'api/Participant';
import { useFetch, useSubmit } from 'hooks';
import SettingsActions from 'store/reducers/Settings';
import UserActions from 'store/reducers/User';
import { formatDataPhoneToSend, formatPhone } from 'utils';

const UserCreditsEdit = ( {
  parentPath, match, history, toggleErrorAlert,
  toggleLoading, userData, updateUser, switchLanguage,
} ) => {
  const entityId = match.params.id;

  const [data, dataLoading] = useFetch( {
    initialState: {},
    promise: () => ParticipantService.getParticipant( entityId ),
    format: ( dataToFormat ) => ( { ...dataToFormat, phone: formatPhone( dataToFormat.phone ) } ),
    toggleErrorAlert,
    conditional: !!entityId,
    deps: [entityId],
  } );

  const submitForm = useSubmit( {
    promise: ( dataToSend ) => ( entityId
      ? ParticipantService.updateParticipant( entityId, dataToSend )
      : ParticipantService.saveParticipant( dataToSend ) ),
    format: ( dataToFormat ) => {
      const phoneCountryCode = parsePhoneNumberFromString( dataToFormat.phone );
      const dataToSend = formatDataPhoneToSend( dataToFormat, ['phone'] );
      dataToSend.phoneCountryCode = phoneCountryCode ? phoneCountryCode.countryCallingCode : null;
      return ( dataToSend );
    },
    toggleLoading,
    callback: ( formData, responseData, dataToSend ) => {
      if ( responseData && responseData.id && responseData.id === userData.id ) {
        updateUser( dataToSend );
        switchLanguage({
          locale: dataToSend.language,
          name: dataToSend.language === "en" ? "english" : "spanish",
        })
      }
      history.push( parentPath );
    },
  } );

  return (
    <UserCreditsEditView
      entityId={entityId}
      data={data}
      parentPath={parentPath}
      isLoading={dataLoading}
      history={history}
      onSubmit={submitForm}
      userData={userData}
    />
  );
};

const mapStateToProps = ( { user } ) => ( {
  userData: user,
} );

const mapDispatchToProps = ( {
  updateUser: UserActions.updateUser,
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
  toggleLoading: SettingsActions.toggleLoading,
  switchLanguage: SettingsActions.switchLanguage,
} );

export default connect( mapStateToProps, mapDispatchToProps )( UserCreditsEdit );
